export const globalInitialState = {
  loading: false,
  error: null,
};

export const videoSavedState = {
  pickedVideofile: null,
};
